import React from 'react';
import styled from 'styled-components';
import Testimonials from '../Testimonials/Testimonials';
import CTA from '../CTA/CTA';
import Footer2 from '../Footer/Footer2.js';
import { Helmet } from 'react-helmet-async';
const Cont = styled.div`
  position: relative;
  z-index: 50;
  margin-bottom: 30vh;
  @media screen and (max-width: 500px) {
    margin-bottom: 44.9vh;
  }
`;

const TestimonialsPage = () => {
  return (
    <>
      <Helmet>
        <title>Testimonials - BRW Construction, Nottingham, Burton Joyce</title>
        <meta
          name="description"
          content="We showcase our recent testimonials so that you know, when working with BRW Construction, you are getting high-end, reliable construction."
        />
        <link rel="canonical" href="/testimonials" />
      </Helmet>
      <Cont>
        <Testimonials />
        <CTA />
      </Cont>
      <Footer2 />
    </>
  );
};

export default TestimonialsPage;
